<template>
    <p class="qrp-text-muted">&copy;{{ year }} QuinStreet Inc. All rights reserved.</p>
</template>

<script>
export default {
  data() {
    return {
      year: null,
    };
  },
  created() {
    const date = new Date();
    this.year = date.getFullYear();
  },
};
</script>

<style scoped>
p {
  color: #989898;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue?2d77eee2